import { CloseIcon } from '~components/icons'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  IconButton,
} from '@mui/material'
import { useAnimatedAlert } from '~components/molecules/animated-alert/animated-alert-provider'
import useBreakpoint from '~hooks/use-breakpoint'
import useDeletePoolFile from '../hooks/use-delete-pool-file'

const DeletePoolDocumentModal = ({
  title,
  id,
  confirmDeleteDialogOpen,
  setConfirmDeleteDialogOpen,
}: {
  title: string
  id: string
  confirmDeleteDialogOpen: boolean
  setConfirmDeleteDialogOpen: (open: boolean) => void
}) => {
  const { isMobileSize } = useBreakpoint()
  const { setStatus } = useAnimatedAlert()
  const { mutateAsync: deleteFile, status: deleteFileStatus } =
    useDeletePoolFile()

  return (
    <Dialog
      open={confirmDeleteDialogOpen}
      fullWidth
      onClose={() => setConfirmDeleteDialogOpen(false)}
    >
      <DialogTitle>{title}</DialogTitle>
      {!isMobileSize && (
        <IconButton
          aria-label="close"
          onClick={() => setConfirmDeleteDialogOpen(false)}
          sx={(theme) => ({
            position: 'absolute',
            right: 8,
            top: 8,
            color: theme.palette.grey[500],
          })}
        >
          <CloseIcon />
        </IconButton>
      )}
      <DialogContent>
        <DialogContentText>
          Are you sure you want to delete this file?
        </DialogContentText>
      </DialogContent>
      <DialogActions sx={{ mt: 4, mb: 2 }}>
        <Button
          color="inherit"
          onClick={() => setConfirmDeleteDialogOpen(false)}
        >
          Cancel
        </Button>
        <Button
          color="error"
          disabled={deleteFileStatus === 'pending'}
          loading={deleteFileStatus === 'pending'}
          onClick={async () => {
            try {
              const response = await deleteFile(id)
              if (response.success) {
                setStatus('Document deleteed successfully.', 3000, 'success')
                setConfirmDeleteDialogOpen(false)
              } else {
                setStatus(
                  'Failed to delete document. Please try again.',
                  3000,
                  'error',
                )
              }
            } catch (error) {
              setStatus(
                'Failed to delete document. Please try again.',
                3000,
                'error',
              )
            }
          }}
        >
          Delete
        </Button>
      </DialogActions>
    </Dialog>
  )
}

export default DeletePoolDocumentModal
